import { RitzAPI, } from '@moderepo/mode-internal-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var DeviceClassesActionType;
(function (DeviceClassesActionType) {
    DeviceClassesActionType["SET_DEVICE_CLASSES"] = "set device classes";
})(DeviceClassesActionType || (DeviceClassesActionType = {}));
export const setDeviceClasses = (projectId, classes) => {
    return {
        type: DeviceClassesActionType.SET_DEVICE_CLASSES,
        projectId,
        classes,
    };
};
/**
 * Get the list of device classes for a given project
 * @param projectId - The id of the project the device classes belonged to
 */
export const fetchDeviceClasses = (projectId) => {
    return async (dataDispatch) => {
        const classes = await RitzAPI.getInstance().getDeviceClasses(projectId);
        await dataDispatch(setDeviceClasses(projectId, classes));
    };
};
